import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, ShoppingCart, ClipboardList, Kanban as KanbanIcon, Package,
  Boxes, Flower2, Users2, BarChart3, Settings as SettingsIcon, LogOut, ChevronDown,
  Building2, UserCircle, Wallet, Menu, X, Store, CalendarDays, MessageSquareText,
  Truck, ArrowLeftRight, ClipboardCheck, Trash2, LayoutList, HandCoins, BookText,
  Award, CalendarClock, ShieldCheck, CreditCard, ScrollText, FileSpreadsheet, Bell, TrendingUp, Landmark, Printer,
  Archive, Repeat, ShieldAlert, PackageMinus, XCircle, Gauge, Droplets, Leaf,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { group: "Utama", items: [
    { to: "/", label: "Dashboard", icon: LayoutDashboard, perm: ["dashboard", "view"] },
    { to: "/pos", label: "Kasir (POS)", icon: ShoppingCart, perm: ["pos", "create"] },
    { to: "/order-center", label: "Order Center", icon: ClipboardList, perm: ["orders", "view"] },
    { to: "/kanban", label: "Tugas Perangkai", icon: KanbanIcon, perm: ["orders", "view"] },
    { to: "/calendar", label: "Kalender", icon: CalendarDays, perm: ["orders", "view"] },
    { to: "/preorders", label: "Pre-Order", icon: CalendarClock, perm: ["orders", "view"] },
    { to: "/whatsapp", label: "WhatsApp → Order", icon: MessageSquareText, perm: ["pos", "create"] },
  ]},
  { group: "Katalog & Stok", items: [
    { to: "/products", label: "Produk", icon: Package, perm: ["products", "view"] },
    { to: "/materials", label: "Bahan & Perlengkapan", icon: Flower2, perm: ["raw_materials", "view"] },
    { to: "/inventory", label: "Inventory / Stok", icon: Boxes, perm: ["inventory", "view"] },
    { to: "/freshness", label: "Kesegaran Bunga", icon: Leaf, perm: ["inventory", "view"] },
    { to: "/shipments", label: "Barang Masuk", icon: Truck, perm: ["goods_receiving", "view"] },
    { to: "/transfers", label: "Transfer Stok", icon: ArrowLeftRight, perm: ["stock_transfer", "view"] },
    { to: "/opname", label: "Stok Opname", icon: ClipboardCheck, perm: ["stock_opname", "view"] },
    { to: "/waste", label: "Bunga Rusak", icon: Trash2, perm: ["waste", "view"] },
    { to: "/stock-daily", label: "Laporan Stok Harian", icon: LayoutList, perm: ["inventory_reports", "view"] },
    { to: "/inventory-dashboard", label: "Dashboard Inventory", icon: Gauge, perm: ["inventory_reports", "view"] },
    { to: "/stock-report", label: "Laporan Stok", icon: Archive, perm: ["inventory_reports", "view"] },
    { to: "/stock-movements", label: "Stock Movement", icon: Repeat, perm: ["inventory_reports", "view"] },
    { to: "/inventory-control-report", label: "Inventory Control", icon: ShieldAlert, perm: ["inventory_reports", "view"] },
    { to: "/daily-usage", label: "Pemakaian Harian", icon: PackageMinus, perm: ["inventory", "view"] },
    { to: "/material-usage", label: "Pemakaian Rangkaian", icon: Boxes, perm: ["production", "view"] },
    { to: "/opname-approval", label: "Approval Opname", icon: ClipboardCheck, perm: ["stock_opname", "approve"] },
    { to: "/consignment", label: "Titip Pasar", icon: Store, perm: ["consignment", "view"] },
    { to: "/consignment-report", label: "Laporan Titip Pasar", icon: Store, perm: ["consignment", "view"] },
  ]},
  { group: "Pelanggan & Keuangan", items: [
    { to: "/customers", label: "Pelanggan (CRM)", icon: Users2, perm: ["customers", "view"] },
    { to: "/receivables", label: "Piutang (AR)", icon: Wallet, perm: ["orders", "view"] },
    { to: "/supplier-debts", label: "Hutang Supplier", icon: HandCoins, perm: ["expenses", "view"] },
    { to: "/cashbook", label: "Buku Kas", icon: BookText, perm: ["cash", "view"] },
    { to: "/accounting", label: "Pengeluaran Akunting", icon: Landmark, perm: ["accounting_expenses", "view"] },
    { to: "/accounting-report", label: "Laporan Akunting", icon: BarChart3, perm: ["accounting_expenses", "view"] },
    { to: "/reports", label: "Laba Rugi", icon: BarChart3, perm: ["profit_reports", "view"] },
    { to: "/profit-report", label: "Laporan Interaktif", icon: BarChart3, perm: ["profit_reports", "view"] },
    { to: "/bu-pnl", label: "P&L Unit Bisnis", icon: TrendingUp, perm: ["profit_reports", "view"] },
    { to: "/sales-report", label: "Laporan Penjualan", icon: TrendingUp, perm: ["sales_reports", "view"] },
    { to: "/payment-report", label: "Omset per Metode Bayar", icon: CreditCard, perm: ["sales_reports", "view"] },
    { to: "/void-report", label: "Transaksi Void", icon: XCircle, perm: ["sales_reports", "view"] },
    { to: "/commissions", label: "Komisi Perangkai", icon: Award, perm: ["payroll", "view"] },
    { to: "/attendance", label: "Absensi & Lembur", icon: CalendarClock, perm: ["attendance", "view"] },
    { to: "/care", label: "Perawatan Bunga", icon: Droplets, perm: ["care", "view"] },
    { to: "/daily-report", label: "Laporan Harian", icon: ClipboardList, perm: ["reports", "view"] },
  ]},
  { group: "Administrasi", items: [
    { to: "/notifications", label: "Notifikasi", icon: Bell },
    { to: "/branches", label: "Cabang / Unit", icon: Building2, perm: ["settings", "view"] },
    { to: "/users", label: "Karyawan", icon: UserCircle, perm: ["employees", "view"] },
    { to: "/roles", label: "Peran & Hak Akses", icon: ShieldCheck, perm: ["employees", "view"] },
    { to: "/payment-methods", label: "Metode Bayar", icon: CreditCard, perm: ["settings", "view"] },
    { to: "/printer", label: "Printer Thermal", icon: Printer, perm: ["settings", "view"] },
    { to: "/bulk", label: "Import/Export Excel", icon: FileSpreadsheet, perm: ["settings", "view"] },
    { to: "/audit-log", label: "Log Audit", icon: ScrollText, perm: ["audit_log", "view"] },
    { to: "/settings", label: "Pengaturan", icon: SettingsIcon, perm: ["settings", "view"] },
  ]},
];

function BranchPicker() {
  const { branch, branches, setBranch } = useAuth();
  const [open, setOpen] = useState(false);
  if (!branches.length) return null;
  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 h-10 px-3 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-sm font-medium text-slate-700"
        data-testid="branch-picker"
      >
        <Store size={16} className="text-primary" />
        <span className="max-w-[160px] truncate">{branch?.name || "Pilih Cabang"}</span>
        <ChevronDown size={15} className="text-slate-400" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-1 w-60 bg-white rounded-xl border border-slate-200 shadow-lg z-20 py-1">
            {branches.map((b) => (
              <button
                key={b.id}
                onClick={() => { setBranch(b); setOpen(false); }}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-50 flex items-center justify-between ${branch?.id === b.id ? "text-primary font-semibold" : "text-slate-700"}`}
                data-testid={`branch-option-${b.code}`}
              >
                <span className="truncate">{b.name}</span>
                <span className="text-xs text-slate-400 uppercase">{b.type}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default function AppShell({ children }) {
  const { user, logout, can, isOwner } = useAuth();
  const nav = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const visible = (item) => isOwner || !item.perm || can(item.perm[0], item.perm[1]);

  const SidebarContent = (
    <>
      <div className="flex items-center gap-2.5 px-5 h-16 border-b border-slate-100">
        <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center text-white">
          <Flower2 size={20} />
        </div>
        <div className="leading-tight">
          <div className="font-bold text-slate-800">FloristOS</div>
          <div className="text-[11px] text-slate-400">POS & ERP Toko Bunga</div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-5">
        {NAV.map((section) => {
          const items = section.items.filter(visible);
          if (!items.length) return null;
          return (
            <div key={section.group}>
              <div className="px-3 text-[11px] font-semibold uppercase tracking-wider text-slate-400 mb-1.5">
                {section.group}
              </div>
              <div className="space-y-0.5">
                {items.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === "/"}
                    onClick={() => setMobileOpen(false)}
                    data-testid={`nav-${item.to.replace(/\//g, "") || "dashboard"}`}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                        isActive ? "bg-primary/10 text-primary" : "text-slate-600 hover:bg-slate-100"
                      }`
                    }
                  >
                    <item.icon size={18} />
                    <span className="truncate">{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          );
        })}
      </nav>
      <div className="border-t border-slate-100 p-3">
        <div className="flex items-center gap-3 px-2 py-2">
          <div className="w-9 h-9 rounded-full bg-primary/15 text-primary flex items-center justify-center font-semibold">
            {(user?.name || "?").charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold text-slate-800 truncate">{user?.name}</div>
            <div className="text-[11px] text-slate-400 truncate">{user?.role_name}</div>
          </div>
          <button
            onClick={() => { logout(); nav("/login"); }}
            className="w-9 h-9 rounded-lg text-slate-400 hover:bg-rose-50 hover:text-rose-600 flex items-center justify-center"
            data-testid="logout-btn"
            title="Keluar"
          >
            <LogOut size={17} />
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-[#F4F8F4] flex">
      <aside className="hidden lg:flex w-64 bg-white border-r border-slate-200 flex-col fixed inset-y-0 left-0 z-30">
        {SidebarContent}
      </aside>

      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-40 flex">
          <div className="w-64 bg-white flex flex-col">{SidebarContent}</div>
          <div className="flex-1 bg-slate-900/40" onClick={() => setMobileOpen(false)} />
        </div>
      )}

      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="sticky top-0 z-20 bg-[#F4F8F4]/80 backdrop-blur border-b border-slate-200/60 h-16 flex items-center justify-between px-4 lg:px-8 gap-3">
          <button className="lg:hidden text-slate-600" onClick={() => setMobileOpen(true)} data-testid="mobile-menu-btn">
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
          <div className="flex-1" />
          <BranchPicker />
        </header>
        <main className="p-4 lg:p-8 max-w-[1400px] mx-auto">{children}</main>
      </div>
    </div>
  );
}
